<button
  mat-icon-button
  [matMenuTriggerFor]="menu"
  aria-label="Example icon-button with a menu"
>
  <img src="/Gridmenu.png" alt="" />
</button>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="onDeleteClick()">
    <span>Move Equipment</span>
  </button>
  <button mat-menu-item (click)="onEditClick()">
    <span>Remove Equipment</span>
  </button>
</mat-menu>
